import Axios from "axios";
import { message } from "antd";

export default function SignInAPI(email, password, onSuccess, onError) {
  return (dispatch) => {
    dispatch({ type: "Loading", payload: true });
    Axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/signin-admin`,
      headers: { "Content-Type": "application/json" },
      data: { email, password },
    })
      .then((response) => {
        dispatch({ type: "Loading", payload: false });
        const data = response.data;
        if (data.status === "mfa_required") {
          if (onSuccess) onSuccess(data);
          return;
        }
        localStorage.setItem("token", data.webToken);
        if (data.data) {
          localStorage.setItem("adminData", JSON.stringify(data.data));
          dispatch({ type: "SET_ADMIN", payload: data.data });
        }
        if (onSuccess) onSuccess(data);
      })
      .catch((err) => {
        dispatch({ type: "Loading", payload: false });
        message.error("Please Check your Email or Password");
        if (onError) onError();
      });
  };
}
